import {SettingsProd} from '../conf/settings-prod';
import {Settings} from '../conf/settings';

export const environment = {
  production: true,
  BASE_URL: 'https://v4.alpha.vaillant-vn.com',
  // OTA-оновлення нативного застосунку: latest.json + zip-пакети, які викладає yarn deploy-mobile
  liveUpdateUrl: 'https://mobile.service.vaillant-vn.com/updates' as string | null,
};

export const settings = new SettingsProd() as Settings;
